module.exports = __webpack_public_path__ + "7f8455b70734a87596991e1f24053edc.svg";